import { useEffect, useState } from "react";
import { PortalShell } from "@/components/AppHeader";
import { TripTable } from "@/components/TripTable";
import { api } from "@/lib/api";

export default function CustomerTrips() {
  const [trips, setTrips] = useState(null);
  useEffect(() => { api.get("/trips").then(({ data }) => setTrips(data)); }, []);
  return (
    <PortalShell>
      <p className="lux-eyebrow">History</p>
      <h1 className="mt-2 text-3xl font-semibold text-amber-50 sm:text-4xl">My trips</h1>
      <div className="lux-card mt-8 p-2 sm:p-4" data-testid="customer-trip-history">
        {trips && <TripTable trips={trips} showDriver testId="customer-trips-table" />}
      </div>
    </PortalShell>
  );
}
